import React from 'react';
import { useNavigate } from "react-router";

import * as CONSTANTS from "../constants";

import IFrame from '../components/iframe';

const iframeURL = `${CONSTANTS.DOMAIN_NAME}/${CONSTANTS.CLIENT_NAME}/website/${CONSTANTS.USE_IFRAMES_FROM}?EventInstanceId=${CONSTANTS.INSTANCE?.iframe_id}&resize=true`;

export default function SwitchToIframes() {
    let navigate = useNavigate();

    // Without the EventInstanceId the iframe quietly fails so make sure the user is sent to basket in that case
    if (!CONSTANTS.INSTANCE?.iframe_id) navigate(`/basket`);

    return (
        <div className='booking-pathway__container booking-pathway__switch-to-iframes'>
            
            <div className='booking-pathway__main-content'>
                <h1 className='sr-text'>Book online</h1>
                <IFrame url={iframeURL} title="Booking" hasLoader="true" />
            </div>
        </div>
    );
}